export const TRIAL_PERIODS = {
  BEGINNING: 'beginning',
  MIDDLE: 'middle',
  FINAL: 'final',
};

export const SUBSCRIPTION_TYPES = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};
